import axios from "axios";
import { COURSE_SERVICE_URL, getHeaders } from "@/apis/common";
import { PREMIUM_DATA_MASK } from "@/constants";

const metadata = () =>
  import(/* webpackChunkName: "metadata" */ "@/data/metadata.json");
const courses = () =>
  import(/* webpackChunkName: "courses" */ "@/data/courses.json");
const ratingsMetadata = () =>
  import(
    /* webpackChunkName: "ratings-metadata" */ "@/data/ratings-metadata.json"
  );

function transformCourses(courses = [], metadata = []) {
  const numericProps = metadata
    .filter(m => m.sortType === "number")
    .map(m => m.id);
  const dateProps = metadata.filter(m => m.sortType === "date").map(m => m.id);
  // will match if the string is not blank and does not start with http or https
  const httpRegex = new RegExp(/^(?!^\s*$)(?!http|https)/);
  const httpPrefix = "http://";
  const transformed = courses.map(course => {
    // convert numeric values to actual numbers
    numericProps.forEach(prop => {
      let p = course[prop];

      if (p === "") {
        return;
      }

      if (p === "Next 50") {
        return;
      }

      if (p === "Other") {
        return;
      }

      if (p === PREMIUM_DATA_MASK) {
        return;
      }

      if (prop === "rating") {
        course[prop] = parseFloat(p);

        return;
      }

      course[prop] = parseInt(p, 10);
    });

    dateProps.forEach(prop => {
      let p = course[prop];

      if (p === "") {
        return;
      }

      if (p === PREMIUM_DATA_MASK) {
        return;
      }

      course[prop] = new Date(p);
    });

    // add an "http" prefix to any course websites that are missing it
    let { OLGDP010: website } = course;
    if (website && website.match(httpRegex)) {
      website = website.replace(httpRegex, httpPrefix);
      course.OLGDP010 = website;
    }

    // add an "http" prefix to any course layouts that are missing it
    let { OLGDP091: courseLayout } = course;
    if (courseLayout && courseLayout.match(httpRegex)) {
      courseLayout = courseLayout.replace(httpRegex, httpPrefix);
      course.OLGDP091 = courseLayout;
    }

    // detect lat/long overrides
    let { latitudeOverride, longitudeOverride } = course;
    if (latitudeOverride || longitudeOverride) {
      course.latitude = latitudeOverride;
      course.longitude = longitudeOverride;
    }

    delete course.latitudeOverride;
    delete course.longitudeOverride;

    course.latitude = parseFloat(course.latitude);
    course.longitude = parseFloat(course.longitude);

    return course;
  });

  return transformed;
}

export function getMetadata() {
  return Promise.all([metadata(), ratingsMetadata()]).then(
    ([meta, ratingsMeta]) => {
      const newMeta = [...meta.default];
      const targetIndexWalkability = newMeta.findIndex(
        m => m.categoryId === "OLGCT008",
      );

      // ghetto, but we want the User Ratings columns to appear before
      // the Walkability columns in the List View
      newMeta.splice(targetIndexWalkability, 0, ...ratingsMeta.default);

      return newMeta;
    },
  );
}

export function getCourses() {
  return Promise.all([metadata(), courses()]).then(results => {
    return transformCourses(results[1].default, results[0].default);
  });
}

export function getCoursesByUid(token) {
  // return mockGetAllByAccessLevel(token);
  return getAllByAccessLevel(token);
}

function getAllByAccessLevel(token) {
  const url = `${COURSE_SERVICE_URL}/private/course`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getCourseById(courses, id) {
  if (!id || !courses || !courses.length) {
    return {};
  }

  return courses.find(c => c.id === id);
}
